/**
 * Aggregates per-portfolio profit summary objects (API: portfolio_profit_summary → portfolios_market_value).
 * Keys are typically Hankintahinta, Markkina_arvo, Realisoitumattomat_tuotot, Realisoituneet_tuotot, …
 */

export function isPortfoliosSummaryEmpty(portfoliosSummary) {
  if (portfoliosSummary == null) return true;
  if (Array.isArray(portfoliosSummary)) return portfoliosSummary.length === 0;
  if (typeof portfoliosSummary === "object") return Object.keys(portfoliosSummary).length === 0;
  return true;
}

export function aggregatePortfoliosSummary(portfoliosSummary) {
  if (isPortfoliosSummaryEmpty(portfoliosSummary)) return null;

  const values = Object.values(portfoliosSummary).filter((v) => v && typeof v === "object" && !Array.isArray(v));
  if (values.length === 0) return null;

  return values.reduce((acc, portfolio) => {
    if (!portfolio || typeof portfolio !== "object") return acc;
    for (const [key, value] of Object.entries(portfolio)) {
      const num = Number(value);
      if (!Number.isFinite(num)) continue;
      acc[key] = (acc[key] || 0) + num;
    }
    return acc;
  }, {});
}
